var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yt-div-edit",attrs:{"contenteditable":"plaintext-only"},domProps:{"innerHTML":_vm._s(_vm.parseText())},on:{"input":function($event){return _vm.changeDivText($event)},"focus":_vm.divFocus,"blur":_vm.divBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }